import { useLocation, useNavigate } from "react-router-dom";
import "./Header.scss";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { useEffect, useState } from "react";

function Header() {
  let navigate = useNavigate();
  let location = useLocation();
  const [openNavigate, setOpenNavigate] = useState(false);
  const navigations = [
    { id: "_hello", label: "_hello", link: "/" },
    { id: "_about-me", label: "_about-me", link: "/_about-me" },
    { id: "_projects", label: "_projects", link: "/_projects" },
    { id: "_contact-me", label: "_contact-me", link: "/_contact-me" },
  ];
  const { width } = useWindowDimensions();
  useEffect(() => {
    if (width && width > 968) {
      setOpenNavigate(false);
    }
  }, [width]);
  return (
    <>
      <div className="header-container">
        <div className="header-container__nav-items-container">
          <div className="header-container__name">
            hamza-rihani
            {!openNavigate ? (
              <svg
                onClick={() => setOpenNavigate(true)}
                className="header-container__open-icon"
                width="18"
                height="16"
                viewBox="0 0 18 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 0H18V2H0V0ZM0 7H18V9H0V7ZM0 14H18V16H0V14Z"
                  fill="#607B96"
                />
              </svg>
            ) : (
              <svg
                onClick={() => setOpenNavigate(false)}
                className="header-container__close-icon"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 6.2225L14.2225 0L16 1.7775L9.7775 8L16 14.2225L14.2225 16L8 9.7775L1.7775 16L0 14.2225L6.2225 8L0 1.7775L1.7775 0L8 6.2225Z"
                  fill="#607B96"
                />
              </svg>
            )}
          </div>
          {navigations.map((item) => (
            <div
              key={item.id}
              style={item.id === "_contact-me" ? { display: "none" } : {}}
              className={`header-container__nav-items ${
                location.pathname === item.link
                  ? "header-container__active-item"
                  : ""
              }`}
              onClick={() => navigate(item.link)}
            >
              {item.label}
            </div>
          ))}
        </div>
        <div
          className={`header-container__nav-items__right ${
            location.pathname === "/_contact-me"
              ? "header-container__active-item"
              : ""
          }`}
          onClick={() => navigate("/_contact-me")}
        >
          _contact-me
        </div>
      </div>
      {openNavigate && (
        <div className="header-container__nav-items-container-mobile">
          {navigations.map((item) => (
            <div
              key={item.id}
              onClick={() => {
                navigate(item.link);
                setOpenNavigate(false);
              }}
              className={`header-container__nav-items-mobile ${
                location.pathname === item.link
                  ? "header-container__active-item-mobile"
                  : ""
              }`}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </>
  );
}

export default Header;
